<!--
 * @Author: your name
 * @Date: 2020-08-05 15:40:34
 * @LastEditTime: 2021-06-02 17:04:44
 * @LastEditors: JDY
 * @Description: In User Settings Edit
 * @FilePath: \new_if_admind:\phpstudy_pro\WWW\lfadmin\src\components\Editor\UEditor.vue
-->
<template>
  <div :class="prefixCls">
    <vue-ueditor-wrap v-model="content" :config="editorConfig"> </vue-ueditor-wrap>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  name: 'Ueditor',
  components: {
    VueUeditorWrap
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-editor-ueditor'
    },
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: String
    }
  },
  data () {
    return {
      content: ``, // 富文本编辑器默认内容
      // 简单配置
      editorConfig: {
        toolbars: [
          [
            'fullscreen',
            'source',
            '|',
            'undo',
            'redo',
            '|',
            'bold',
            'italic',
            'underline',
            'fontborder',
            'strikethrough',
            'superscript',
            'subscript',
            'removeformat',
            'formatmatch',
            'autotypeset',
            'blockquote',
            'pasteplain',
            '|',
            'forecolor',
            'backcolor',
            'insertorderedlist',
            'insertunorderedlist',
            'selectall',
            'cleardoc',
            '|',
            'rowspacingtop',
            'rowspacingbottom',
            'lineheight',
            '|',
            'customstyle',
            'paragraph',
            'fontfamily',
            'fontsize',
            '|',
            'directionalityltr',
            'directionalityrtl',
            'indent',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'justifyjustify',
            '|',
            'touppercase',
            'tolowercase',
            '|',
            'link',
            'unlink',
            'anchor',
            '|',
            'imagenone',
            'imageleft',
            'imageright',
            'imagecenter',
            '|',
            'simpleupload',
            'insertimage',
            'emotion',
            'scrawl',
            'insertvideo',
            'music',
            'attachment',
            'map',
            'gmap',
            'insertframe',
            'insertcode',
            'webapp',
            'pagebreak',
            'template',
            'background',
            '|',
            'horizontal',
            'date',
            'time',
            'spechars',
            'snapscreen',
            'wordimage',
            '|',
            'inserttable',
            'deletetable',
            'insertparagraphbeforetable',
            'insertrow',
            'deleterow',
            'insertcol',
            'deletecol',
            'mergecells',
            'mergeright',
            'mergedown',
            'splittocells',
            'splittorows',
            'splittocols',
            'charts',
            '|',
            'print',
            'preview',
            'searchreplace',
            'drafts',
            'help'
          ]
        ],
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: 'https://chancefoundation.com.cn/editor/php/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/ueditor/'
      }
    }
  },
  methods: {},
  watch: {
    value (val) {
      this.content = val
    },
    content (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="less">
.edui-editor {
  .edui-toolbar {
    line-height: 1.5;
  }
}
#edui_fixedlayer {
    z-index: 9999 !important;
}
</style>
